export default {
  "content": "<path d=\"M36 2.16A2.16 2.16 0 0033.84 0h-6.93a11.039 11.039 0 00-8.61 4.149.377.377 0 01-.585 0A11.038 11.038 0 009.09 0H2.16a2.16 2.16 0 000 4.32h6.93a6.757 6.757 0 016.75 6.75v15.915a.375.375 0 01-.375.375H13.68a2.16 2.16 0 00-1.53 3.69l4.317 4.317c.203.203.444.364.71.473l.031.01a2.11 2.11 0 001.578 0l.031-.01c.266-.109.508-.27.71-.473l4.323-4.317a2.16 2.16 0 00-1.53-3.69h-1.785a.375.375 0 01-.375-.375V11.07a6.758 6.758 0 016.75-6.75h6.93A2.16 2.16 0 0036 2.16z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "36",
    "height": "36",
    "viewBox": "0 0 36 36",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};